import * as yup from "yup";

export const FarmTranningSchema = yup.object().shape({
  farmTrainingDate: yup.string(),
});
